import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickableLink } from '../shared/clickable-link/clickable-link';
import { CallUsButton } from '../shared/call-us-button/call-us-button';
import { PatientPortalButton } from '../shared/patient-portal-button/patient-portal-button';
@Component({
  selector: 'app-returning-patient',
  imports: [CommonModule, ClickableLink, CallUsButton, PatientPortalButton],
  templateUrl: './returning-patient.html',
  styleUrl: './returning-patient.css',
})
export class ReturningPatient {
  @Input() isVisible: boolean = false;
  @Output() modalClosed = new EventEmitter<void>();

  closeModal() {
    this.isVisible = false;
    this.modalClosed.emit();
  }


}
